export const BUCKETS = [
  { key: "completed", label: "Completed", color: "success.main" },
  { key: "inProgress", label: "In Progress", color: "warning.main" },
  { key: "withdrawn", label: "Withdrawn", color: "error.main" },
];

export const formatCount = (value) => Number(value || 0).toLocaleString();

export const completionRate = (row) => {
  const total = Number(row?.totalAdmissions || 0);
  if (!total) return null;
  return Math.round((Number(row?.completed || 0) / total) * 100);
};

export { formatDisplayDate as formatDate } from "utils/dateFormat";
